module.exports = __webpack_public_path__ + "img/red_066.51f4a25d.png";